/**
 * Social Share
 *
 * @global jQuery
 * @requires plugins/jquery.social.js
 * @author Daniele De Nobili
 */

if (typeof fb_appId !== 'undefined') {
    $('.social').social({
        template: {
            'facebook-share': '<a href="#" class="social__link"><span class="social__icon"></span></a>',
            'linkedin': '<a href="#" class="social__link"><span class="social__icon"></span></a>',
            'twitter': '<a href="#" class="social__link"><span class="social__icon"></span><span class="social__count">Tweet</span></a>',
            'pinterest': '<a href="#" class="social__link"><span class="social__icon"></span><span class="social__count">Pin</span></a>'
        },
        totalShareSelector: '#social-count',
        lang: fb_lang || 'en_US',
    });
}
